<template>
  <div id="sidebar" :class="[side]">

    <img
      v-if="$parent.intakeAdmin.beleggen.brand == 'VMVB' && logo==true"
      class="logo" src="../../assets/vm/VM-logo1.svg"
    />
    <img
      v-if="$parent.intakeAdmin.beleggen.brand == 'OXBY' && logo==true"
      class="logo" src="../../assets/ox/OX-logo2.svg"
    />
    <img
      v-if="$parent.intakeAdmin.beleggen.brand == 'BVS' && logo==true"
      class="logo" src="../../assets/bvs/BVS-logo2.svg"
    />
    <img
      v-if="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'"
      class="logo" style="max-width:70px" src="../../assets/db/DB-logo2.svg"
    />

    <span class="close-mobile-menu" @click="close()">Sluiten <awesomeIcon icon="times"/></span>

    <ul class="menu">
      <li
        v-for="(item, index) in filter(
          $parent.menu,
          o => o.id == 1 || $parent.intake.started || $parent.role > 7 || $parent.redo,
        )"
        :key="index" :class="{
          'active': item.focus,
          'grey': !$parent.intake.started && item.id != 1
            && (!$parent.redo
                || (
                    $parent.redo
                    && $parent.role > 7
                    && Number(sumBy(
                        filter($parent.intake.transferData.overdrachten, 'bedrag'),
                        (o) => Number(o.bedrag),
                      )) == 0
                    && $parent.intake.goalData.box === '1'
                  )
            ),
        }"
      >
        <div class="button" @click="$parent.storeIntake(item.id, item.subId);close();">
          <awesomeIcon
            v-if="item.icon" :icon="item.valid ? 'check' : item.icon"
            :rotation="item.rotation"
          />
          {{item.name}}
        </div>
      </li>
    </ul>

    <slot></slot>

  </div>
</template>

<script>
import { filter, sumBy } from 'lodash-es';

export default {
  name: 'sideBar',
  props: {
    side: {
      type: String,
      required: true,
      default: 'left',
    },
    logo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: '',
    };
  },
  methods: {
    sumBy,
    filter,
    close() {
      if (!window.matchMedia('(min-width: 800px)').matches) {
        document.getElementById('sidebar').style.display = 'none';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grey {
  font-style: italic;
}
@media print {
  #sidebar { display: none; }
}
@media screen and (min-width: 988px) {
  #sidebar {
    &.left { left: 0; }
    &.right { right: 0; }
    width: 220px;
    position: fixed;
    top: 0;
    bottom: 0;
    background-color: $color-background;
    color: #fff;
    z-index: 1;
    :slotted(ul), ul, li {
      margin: 0;
      padding: 0;
      list-style-type: none;
    }
    li.active .button {
      color: $color-highlight;
      opacity: 1;
    }
    :slotted(.button), .button {
      background-image: linear-gradient(90deg, $color-background, lighten($color-background, 10%));
      padding: 10px 12px 10px 70px;
      position: relative;
      text-align: left;
      cursor: pointer;
      width: 100%;
      height: 100%;
      min-height: 34px;
      line-height: 14px;
      box-sizing: border-box;
      color: #fff;
      opacity: .8;
      &:hover {
        background-image: linear-gradient(
          90deg,
          lighten($color-background, 10%),
          lighten($color-background, 10%)
        );
        opacity: 1;
      }
      .notification {
        position: absolute;
        top: 5px;
        left: 49px;
      }
      svg {
        position: absolute;
        left: 40px;
      }
    }
    .logo {
      width: 100px;
      height: 100px;
      margin: 40px auto;
      display: block;
    }
    .close-mobile-menu {
      display: none;
    }
  }
}
@media screen and (max-width: 988px) {
  #sidebar {
    display: none;
    overflow: auto;
    background: rgba(0, 0, 0, 0.9);
    z-index: 99;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    color: #fff;
    padding: 40px 20px;
    .dropdown {
      display: none;
    }
    .logo {
      display: none;
    }
    li {
      cursor: pointer;
    }
    svg {
      color: $color-highlight;
      margin-right: 5px;
    }
    .button {
      margin: 0;
      padding: 0;
      text-align: left;
      background-color: transparent;
      color: #fff;
    }
    ul {
      padding: 10px;
      margin: 10px;
      list-style-type: none;
      line-height: 1em;
    }
    li {
      list-style-type: none;
      line-height: 1em;
      display: block;
      margin: 0px;
      padding: 10px;
      position: relative;
      color: inherit;
    }
    .close-mobile-menu {
      cursor: pointer;
      top: 0;
      right: 0;
      position: absolute;
      padding: 20px 30px;
      color: #fff;
      z-index: 99;
    }
  }
}
</style>
